module.exports = __webpack_public_path__ + "static/media/gptDataMuti.46be1c52.mp4";